import type { S3ClientConfig } from "@aws-sdk/client-s3";

export const localS3Overrides = (): Partial<S3ClientConfig> => {
  const endpoint = import.meta.env.VITE_S3_ENDPOINT;
  if (!endpoint) return {};
  return {
    endpoint,
    forcePathStyle: true,
    credentials: {
      accessKeyId: import.meta.env.VITE_S3_ACCESS_KEY_ID ?? "",
      secretAccessKey: import.meta.env.VITE_S3_SECRET_ACCESS_KEY ?? "",
    },
    requestChecksumCalculation: "WHEN_REQUIRED",
    responseChecksumValidation: "WHEN_REQUIRED",
  };
};
